module.exports = __webpack_public_path__ + "static/media/imgll1.600797ab.jpg";